import { PageHeader } from '@/components/page-header'
import { getMonth, getYear } from 'date-fns'
import { useSearchParams } from 'react-router-dom'
import { TaxGuidesDisclaimers } from './tax-guides-disclaimers'
import { TaxGuidesFilters } from './tax-guides-filters'
import { TaxPaymentSlipList } from './tax-payment-slip-list'

function parseMonth(value: string) {
  const month = Number(value)
  if (!Number.isInteger(month) || month < 1 || month > 12) return undefined

  return month
}

function parseYear(value: string) {
  const year = Number(value)
  if (!Number.isInteger(year) || year < 2000) return undefined

  return year
}

export function TaxesPage() {
  const [searchParams] = useSearchParams()
  const now = new Date()
  const currentMonth = getMonth(now) + 1
  const currentYear = getYear(now)
  const monthParam = searchParams.get('m')
  const yearParam = searchParams.get('y')

  const selectedMonth =
    monthParam === null || monthParam === 'all'
      ? undefined
      : (parseMonth(monthParam) ?? currentMonth)
  const selectedYear =
    yearParam === null || yearParam === 'all'
      ? undefined
      : (parseYear(yearParam) ?? currentYear)
  const paidParam = searchParams.get('paid')
  const paidFilter =
    paidParam === 'true' || paidParam === 'all' ? paidParam : 'false'
  const paid =
    paidFilter === 'true' ? true : paidFilter === 'false' ? false : undefined

  return (
    <>
      <PageHeader>Guias de Impostos</PageHeader>
      <TaxGuidesDisclaimers />
      <TaxGuidesFilters
        month={selectedMonth ? String(selectedMonth) : 'all'}
        paid={paidFilter}
        year={selectedYear ? String(selectedYear) : 'all'}
      />
      <TaxPaymentSlipList
        month={selectedMonth}
        paid={paid}
        year={selectedYear}
      />
    </>
  )
}
